import { normalizeAskGuruQuery } from './askBhriguQueryNormalize';

const VAGUE_MSG_EN =
  'Please ask a clear Jyotisha question in a few words (rashis, houses, dashas, nakshatras).';
const VAGUE_MSG_HI = 'कृपया स्पष्ट ज्योतिष प्रश्न पूछें (कुछ शब्दों में - राशि, भाव, दशा, नक्षत्र)।';

const GIBBERISH_MSG_EN =
  'That doesn\'t look like a real question. Try e.g. "What does Rahu in the 8th house mean?"';
const GIBBERISH_MSG_HI =
  'यह वास्तविक प्रश्न नहीं लगता। उदाहरण: "राहु 8वें भाव में क्या करता है?"';

/**
 * @param {string} trimmed
 * @returns {boolean}
 */
function isGibberish(trimmed) {
  if (/^[\s\p{P}\p{S}]+$/u.test(trimmed)) return true;

  const compact = trimmed.replace(/\s/g, '');
  if (compact.length >= 4 && /^(.)\1{3,}$/u.test(compact)) return true;
  if (compact.length >= 4 && new Set(compact).size <= 1) return true;

  if (trimmed.length >= 6 && !/\s/.test(trimmed) && /^[a-z]+$/i.test(trimmed)) {
    const vowels = (trimmed.match(/[aeiou]/gi) || []).length;
    if (vowels === 0) return true;
    if (vowels / trimmed.length < 0.15) return true;
  }

  return false;
}

/**
 * @param {string} query
 * @param {object} [_opts]
 * @returns {{ valid: boolean; code: 'too_short' | 'too_vague' | 'gibberish' | 'ok'; messageEn: string; messageHi: string }}
 */
export function validateAskGuruQuestion(query, _opts = {}) {
  const trimmed = String(query || '').trim();

  if (!trimmed || trimmed.length < 8) {
    return { valid: false, code: 'too_short', messageEn: VAGUE_MSG_EN, messageHi: VAGUE_MSG_HI };
  }

  if (isGibberish(trimmed)) {
    return { valid: false, code: 'gibberish', messageEn: GIBBERISH_MSG_EN, messageHi: GIBBERISH_MSG_HI };
  }

  const wordTokens = trimmed.split(/\s+/).filter(Boolean);
  const { contentTokens, isJyotishaSignal } = normalizeAskGuruQuery(trimmed);

  if (wordTokens.length < 2 && !isJyotishaSignal) {
    return { valid: false, code: 'too_vague', messageEn: VAGUE_MSG_EN, messageHi: VAGUE_MSG_HI };
  }

  if (contentTokens.length === 0 && !isJyotishaSignal) {
    return { valid: false, code: 'too_vague', messageEn: VAGUE_MSG_EN, messageHi: VAGUE_MSG_HI };
  }

  const allowed =
    contentTokens.length >= 2 ||
    (isJyotishaSignal && contentTokens.length >= 1) ||
    (wordTokens.length >= 3 && (contentTokens.length >= 1 || isJyotishaSignal));

  if (!allowed) {
    return { valid: false, code: 'too_vague', messageEn: VAGUE_MSG_EN, messageHi: VAGUE_MSG_HI };
  }

  return { valid: true, code: 'ok', messageEn: '', messageHi: '' };
}

/**
 * @param {{ messageEn: string; messageHi: string }} validation
 * @param {boolean} showEnglish
 */
export function getAskGuruValidationMessage(validation, showEnglish) {
  return showEnglish ? validation.messageEn : validation.messageHi;
}
